var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhoWeAreUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08082 20.9981C7.08082 18.3477 8.11278 15.8581 9.98495 13.9831C11.86 12.1081 14.3496 11.0789 17 11.0789C19.6504 11.0789 22.14 12.1109 24.015 13.9831C25.89 15.8581 26.9191 18.3477 26.9191 20.9981C26.9191 22.281 26.6767 23.5272 26.2143 24.6861C27.9539 22.6053 29 19.9239 29 17C29 10.3712 23.6287 5 17 5C10.3712 5 5 10.3712 5 17C5 19.9239 6.04605 22.6053 7.78571 24.6861C7.3233 23.5301 7.08082 22.2838 7.08082 20.9981Z",
    fill: "#95A4C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29.0002C19.2096 29.0002 21.0009 27.2089 21.0009 24.9992C21.0009 22.7896 19.2096 20.9983 17 20.9983C14.7903 20.9983 12.999 22.7896 12.999 24.9992C12.999 27.2089 14.7903 29.0002 17 29.0002Z",
    fill: "#95A4C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0814 24.9991C11.0814 21.7341 13.7374 19.0781 17.0025 19.0781C20.2675 19.0781 22.9235 21.7341 22.9235 24.9991C22.9235 25.5602 22.8446 26.1044 22.6951 26.6204C24.1218 25.1768 25.0015 23.1918 25.0015 21.001C25.0015 16.5828 21.4207 13.002 17.0025 13.002C12.5842 13.002 9.00342 16.5828 9.00342 21.001C9.00342 23.1918 9.88312 25.1768 11.3098 26.6204C11.1632 26.1044 11.0814 25.563 11.0814 24.9991Z",
    fill: "#95A4C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29.0002C19.2096 29.0002 21.0009 27.2089 21.0009 24.9992C21.0009 22.7896 19.2096 20.9983 17 20.9983C14.7903 20.9983 12.999 22.7896 12.999 24.9992C12.999 27.2089 14.7903 29.0002 17 29.0002Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoWeAreUnselected);
export default __webpack_public_path__ + "static/media/whoWeAreUnselected.76071d29757392f6b59f5b1ec4965891.svg";
export { ForwardRef as ReactComponent };